(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rewards-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const popup = document.getElementById('rewards-popup');
    if (!popup) return;

    let lastFocused = null;

    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(', ');

    const getFocusable = () => Array.from(popup.querySelectorAll(focusableSelectors));

    const trapFocus = (e) => {
      if (e.key !== 'Tab') return;
      const focusable = getFocusable();
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    const openPopup = () => {
      lastFocused = document.activeElement;
      popup.removeAttribute('hidden');
      document.documentElement.classList.add('bst-scroll-lock');
      popup.addEventListener('keydown', trapFocus);
      popup.querySelector('.bst-rewards-popup__close').focus();
    };

    const closePopup = () => {
      popup.setAttribute('hidden', '');
      document.documentElement.classList.remove('bst-scroll-lock');
      popup.removeEventListener('keydown', trapFocus);
      if (lastFocused) lastFocused.focus();
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[href="#trigger-rewards-popup"]');
      if (!trigger) return;
      e.preventDefault();
      openPopup();
    });

    popup.querySelector('.bst-rewards-popup__overlay').addEventListener('click', closePopup);
    popup.querySelector('.bst-rewards-popup__close').addEventListener('click', closePopup);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !popup.hasAttribute('hidden')) {
        closePopup();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
